<template>
    <div id="qrRenderX2" class="member-card">
        <div class="card-header-bar">
            <img src="@/assets/images/client_logo_alpha.webp" alt="Logo" class="card-logo" />
            <span class="card-title">MEMBER CARD</span>
        </div>
        <div class="card-body-content">
            <div class="card-info">
                <div class="card-member-name">{{ memberData.member_name }}</div>
                <div class="card-field">
                    <span class="card-label">Member No.</span>
                    <span class="card-value card-mono">{{ memberData.member_number }}</span>
                </div>
                <div class="card-field">
                    <span class="card-label">Since</span>
                    <span class="card-value">{{ memberData.accepted_membership_date | humanReadableDate }}</span>
                </div>
            </div>
            <div class="card-qr">
                <div class="card-qr-frame">
                    <img v-if="qrDataUrl" :src="qrDataUrl" alt="QR Code" class="card-qr-img" />
                </div>
                <div class="card-qr-caption">Scan to verify</div>
            </div>
        </div>
        <div class="card-footer-bar"></div>
    </div>
</template>

<script>
import * as html2pdf from "../../plugins/html2pdf/html2pdf.bundle.min";
import QRCode from 'qrcode'
export default {
    data: () => ({
        generateOn: false,
        qrDataUrl: null
    }),
    props: {
        memberData: {
            required: true
        }
    },
    filters: {
        humanReadableDate(value) {
            if (!value) return '';

            const date = new Date(value);
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            };

            return date.toLocaleDateString('en-US', options);
        },
    },
    watch: {
        'memberData.download_token': {
            handler(newVal) {
                const qrValue = newVal || (this.memberData && this.memberData.member_number) || '';
                if (qrValue) {
                    this.generateQrDataUrl(qrValue);
                }
            },
            immediate: true,
        },
    },
    methods: {
        generateQrDataUrl(value) {
            QRCode.toDataURL(value, {
                errorCorrectionLevel: 'M',
                width: 250,
                margin: 1,
            })
            .then(url => {
                this.qrDataUrl = url;
            })
            .catch(err => {
                //eslint-disable-next-line
                console.error('QR generation failed:', err);
            });
        },
        exportCard() {
            const wrapper = this.$el.parentElement;
            if (!wrapper) return;

            const originalStyle = wrapper.style.cssText;
            wrapper.style.cssText = 'position:fixed; left:-9999px; top:0; display:block;';

            this.$nextTick(() => {
                const element = this.$el;
                const opt = {
                    margin: [0, 0, 0, 0],
                    filename: 'membercard.pdf',
                    image: { type: 'jpeg', quality: 1 },
                    html2canvas: {
                        scale: 2,
                        useCORS: true,
                        logging: false,
                        width: element.offsetWidth,
                        height: element.offsetHeight,
                    },
                    jsPDF: { unit: 'px', format: [element.offsetWidth, element.offsetHeight], orientation: 'landscape' },
                };

                html2pdf()
                    .set(opt)
                    .from(element)
                    .toPdf()
                    .get('pdf')
                    .then(pdf => {
                        while (pdf.internal.getNumberOfPages() > 1) {
                            pdf.deletePage(2);
                        }
                    })
                    .save()
                    .then(() => {
                        wrapper.style.cssText = originalStyle;
                        this.generateOn = false;
                    })
                    .catch(() => {
                        wrapper.style.cssText = originalStyle;
                        this.generateOn = false;
                    });
            });
        }
    },
    created: function () {
        this.$eventHub.$on('renderCard', this.exportCard);
    },
    beforeDestroy: function () {
        this.$eventHub.$off('renderCard');
    }
};
</script>

<style lang="scss" scoped>
.member-card {
    width: 180mm;
    height: 90mm;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    overflow: hidden;
}

.card-header-bar {
    background: #6C63FF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    flex-shrink: 0;
}

.card-logo {
    height: 40px;
    width: auto;
}

.card-title {
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 2px;
}

.card-body-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    flex: 1;
}

.card-info {
    flex: 1;
    padding-right: 16px;
}

.card-member-name {
    font-size: 20px;
    font-weight: 700;
    color: #1A1A1A;
    margin-bottom: 12px;
    line-height: 1.2;
}

.card-field {
    margin-bottom: 6px;
}

.card-label {
    display: block;
    font-size: 10px;
    font-weight: 600;
    color: #999999;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1.3;
}

.card-value {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #555555;
    line-height: 1.4;
}

.card-mono {
    font-family: 'JetBrains Mono', 'Fira Code', monospace;
}

.card-qr {
    flex-shrink: 0;
    text-align: center;
}

.card-qr-frame {
    display: inline-block;
    padding: 6px;
    border: 2px solid #E0E0E0;
    border-radius: 6px;
}

.card-qr-frame .card-qr-img {
    display: block;
    width: 125px;
    height: 125px;
}

.card-qr-caption {
    font-size: 9px;
    color: #999999;
    margin-top: 4px;
    letter-spacing: 0.3px;
}

.card-footer-bar {
    height: 4px;
    background: #4ECDC4;
    flex-shrink: 0;
}
</style>
